import { DeleteFilled, PlusOutlined } from '@ant-design/icons';
import { Button, Input, Select } from 'antd';
import { Trans, useTranslation } from 'react-i18next';

import { UserCollectionSerializer } from '../../types/api';
import Form from '../Form';

export interface RequestJobPostingTemplateFormProps {
  users: UserCollectionSerializer[];
}

interface RequestJobPostingTemplateStageValue {
  name: string;
  sequence: number;
  approver: number;
}

export interface RequestJobPostingTemplateFormValues {
  name: string;
  templateStages: RequestJobPostingTemplateStageValue[];
}

const RequestJobPostingTemplateForm = ({ users }: RequestJobPostingTemplateFormProps) => {
  const { t } = useTranslation();

  const form = Form.useFormInstance();

  return (
    <>
      <Form.Item label={t('Nome do modelo')} name="name" rules={[{ required: true }]}>
        <Input />
      </Form.Item>
      <Form.List
        name="templateStages"
        rules={[
          {
            validator(_, value) {
              if (value.length === 0) {
                return Promise.reject(new Error(t('Adicione uma etapa.')));
              }
              return Promise.resolve();
            },
          },
        ]}
      >
        {(fields, { add, remove }, { errors }) => (
          <>
            {fields.map(({ key, name }, index) => {
              return (
                <Form.Row key={key}>
                  <Form.Col span={12}>
                    <Form.Item
                      label={`${index + 1}. ${t('Etapa')}`}
                      name={[name, 'name']}
                      validateFirst
                      validateTrigger="onChange"
                      rules={[{ required: true, message: t('Por favor, insira a Etapa') }]}
                    >
                      <Input />
                    </Form.Item>
                  </Form.Col>
                  <Form.Col span={10}>
                    <Form.Item
                      name={[name, 'approver']}
                      label={<></>}
                      rules={[
                        {
                          validator(_, value: number | undefined) {
                            if (!value) {
                              form.getFieldError([name, 'approver']);
                              return Promise.reject(new Error(t('Por favor, insira o aprovador')));
                            }

                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <Select
                        allowClear
                        showSearch
                        filterOption={(input, option) =>
                          (option?.children as unknown as string)
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        placeholder={t('Aprovador')}
                      >
                        {users.map((user) =>
                          user.full_name ? (
                            <Select.Option key={user.id} value={user.id}>
                              {user.full_name}
                            </Select.Option>
                          ) : (
                            <Select.Option key={user.id} value={user.id}>
                              {user.username}
                            </Select.Option>
                          )
                        )}
                      </Select>
                    </Form.Item>
                  </Form.Col>
                  <Form.Col>
                    <Form.Item label={<></>}>
                      <DeleteFilled onClick={() => remove(name)} />
                    </Form.Item>
                  </Form.Col>
                </Form.Row>
              );
            })}
            <Button type="ghost" onClick={() => add({})} block icon={<PlusOutlined />}>
              {' '}
              <Trans>Adicionar etapa</Trans>
            </Button>
            <Form.ErrorList errors={errors} />
          </>
        )}
      </Form.List>
    </>
  );
};

export default RequestJobPostingTemplateForm;
